import { useNavigate } from "react-router-dom";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { GoogleButton } from "@/components/GoogleButton";
import { Clapperboard, Utensils, Wine, Globe, Star } from "lucide-react";

const perks = [
  { icon: Utensils, text: "Unlimited movie pairings" },
  { icon: Star, text: "Save & rate your collection" },
  { icon: Globe, text: "Explore the community feed" },
  { icon: Wine, text: "Wine & soundtrack pairings" },
];

export const AccountGateDialog = ({
  open,
  onOpenChange,
  title = "Create your free account",
  description = "You've reached the guest limit. Sign up free to unlock the full experience.",
}) => {
  const navigate = useNavigate();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#0d0d0d] border-white/10 max-w-md" data-testid="account-gate-dialog">
        <DialogHeader>
          <div className="w-12 h-12 rounded-full bg-[#E50914]/15 flex items-center justify-center mb-2">
            <Clapperboard className="w-6 h-6 text-[#E50914]" />
          </div>
          <DialogTitle className="font-display text-2xl">{title}</DialogTitle>
          <DialogDescription className="text-white/60">{description}</DialogDescription>
        </DialogHeader>

        <ul className="space-y-3 my-2">
          {perks.map((p, i) => (
            <li key={i} className="flex items-center gap-3 text-sm text-white/80">
              <p.icon className="w-4 h-4 text-[#F5B841]" />
              {p.text}
            </li>
          ))}
        </ul>

        <DialogFooter className="flex-col gap-2 sm:flex-col">
          <Button
            onClick={() => navigate("/register")}
            data-testid="gate-signup-btn"
            className="w-full rounded-full bg-[#E50914] hover:bg-[#c00811] text-white h-11 text-base"
          >
            Sign Up Free
          </Button>
          <div className="flex items-center gap-3 w-full">
            <span className="h-px flex-1 bg-white/10" />
            <span className="text-xs text-white/40 uppercase tracking-widest">or</span>
            <span className="h-px flex-1 bg-white/10" />
          </div>
          <GoogleButton label="Continue with Google" testid="gate-google-btn" />
          <button
            onClick={() => navigate("/login")}
            data-testid="gate-login-btn"
            className="text-sm text-white/60 hover:text-white transition-colors"
          >
            Already have an account? Log in
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
